/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2023-10-12 14:04:03
 * @LastEditors: sueRimn
 * @LastEditTime: 2023-11-22 19:32:24
 */
import request from '@/utils/request'
import type * as project from '@/typings/project'

interface IGetFinancingHistoryRequest {
  project_id: number
}
// 新增项目融资历史接口
export async function getFinancingHistory(params: IGetFinancingHistoryRequest) {
  return request('/api/v2/project/project_financing_history_list', {
    method: 'GET',
    data: params
  })
}

interface IUpdateFinancingHistoryRequest {
  financing_history: project.ProjectFinancingHistory
}

// 编辑项目融资历史接口
export async function updateFinancingHistory(params: IUpdateFinancingHistoryRequest) {
  return request('/api/v2/project/project_financing_history_update', {
    method: 'POST',
    data: params
  })
}
